import Physician from "../../../Physician/Models/Physician";
import CCBlockSummaryAnnualFeesMeeting from "./CCBlockSummaryAnnualFeesMeeting";
import CCBlockSummaryAnnualFeesNotMeeting from "./CCBlockSummaryAnnualFeesNotMeeting";


interface IProps{
    physician: Physician;
    showNotMeeting: boolean;
}

export default function CCBlockSummaryAnnualFeesCard(props: IProps) {

    if (props.showNotMeeting){
        return (
            <CCBlockSummaryAnnualFeesNotMeeting physician={props.physician} />);
    }
    else {
        return( 
            <CCBlockSummaryAnnualFeesMeeting physician={props.physician} />);
    }
}